import axios from "axios";

const url = process.env.REACT_APP_API_KEY;

export const GetCustomerByNIN = (identityNumber, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}Customer/GetCustomerByNationalIdentityNumber?IdentityNumber=${identityNumber}`,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};

export const GetFinancingRequestAccountingHistory = (
  FinancingRequestId,
  FinancingRequestTypeId,
  onSuccess,
  onFail
) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}FinancingRequest/GetFinancingRequestAccountingHistory?FinancingRequestId=${FinancingRequestId}&FinancingRequestTypeId=${FinancingRequestTypeId}`,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};

export const DeleteOrder = (id, onSucess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "delete",
    url: `${url}FinancingRequest/DeleteFinancingRequest?FinancingRequestId=${id}`,
    // data: body,
    headers,
  })
    .then((response) => {
      return onSucess(response);
    })
    .catch((err) => onFail(err));
};

export const GetCustomerById = (id, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}Customer/GetCustomerById?CustomerId=${id}`,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};

export const UpdateFinancingRequestStatus = (
  FinancingRequestId,
  FinanceRequestStatusId,
  onSuccess,
  onFail
) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}FinancingRequest/UpdateFinancingRequestStatus?FinancingRequestId=${FinancingRequestId}&FinanceRequestStatusId=${FinanceRequestStatusId}`,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};

export const UpdateFinancingRequestGeneralStatus = (
  FinancingRequestId,
  FinancingRequestGeneralStatusId,
  onSuccess,
  onFail
) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}FinancingRequest/UpdateFinancingRequestGeneralStatus?FinancingRequestId=${FinancingRequestId}&FinancingRequestGeneralStatusId=${FinancingRequestGeneralStatusId}`,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};

export const UpdateOrderStatus = (
  FinancingRequestId,
  FinancingRequestGeneralStatusId,
  onSuccess,
  onFail
) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}FinancingRequest/UpdateOrderStatus?OrderId=${FinancingRequestId}&StatusId=${FinancingRequestGeneralStatusId}`,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};

export const AssignFinancingRequestToContactEmployee = (
  FinancingRequestId,
  ContactEmployeeId,
  onSuccess,
  onFail
) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}FinancingRequest/AssignFinancingRequestToContactEmployee?FinancingRequestId=${FinancingRequestId}&ContactEmployeeId=${ContactEmployeeId}`,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err.response.data.errors));
};

export const AssignFinancingRequestToQualityEmployee = (
  FinancingRequestId,
  QualityEmployeeId,
  onSuccess,
  onFail
) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}FinancingRequest/AssignFinancingRequestToQualityEmployee?FinancingRequestId=${FinancingRequestId}&QualityEmployeeId=${QualityEmployeeId}`,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err.response.data.errors));
};

export const GetFinancingRequestDetails = (id, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}FinancingRequest/GetFinancingRequestDetails?FinancingRequestId=${id}`,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};

export const SearchInCustomerForObligations = (value, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}Obligations/SearchInCustomerForObligations?word=${value}`,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};

export const GetOsoolEmployees = (Page, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}Employee/GetOsoolEmployees?Page=${Page}`,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};

export const GetOsoolContactEmployees = (Page, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}Employee/GetOsoolContactEmployees?Page=${Page}`,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};

export const GetOsoolQualityEmployees = (Page, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}Employee/GetOsoolQualityEmployees?Page=${Page}`,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};

export const GetAllFinancingAgencyEmployees = (Page, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}FinancingAgencyEmployee/GetAllFinancingAgencyEmployees?Page=${Page}`,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};

export const GetObligations = (body, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}Obligations/GetObligations${body}`,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};

export const RegisterCustomer = (body, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "post",
    url: `${url}RegisterCustomer`,
    data: body,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err.response.data.errors));
};

export const GetFinancingRequestAccounting = (body, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}FinancingRequest/GetFinancingRequestAccounting${body}`,
    // data:body,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err.response.data.errors));
};

export const ChooseFinancingRequestAccounting = (body, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "post",
    url: `${url}FinancingRequest/ChooseFinancingRequestAccounting`,
    data: body,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err.response.data.errors));
};

export const AddModifiedFinancingRequestAccounting = (
  body,
  onSuccess,
  onFail
) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "post",
    url: `${url}FinancingRequest/AddAccountingForOsoolEmployee`,
    data: body,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err.response.data.errors));
};

export const AddOrUpdateIndebtedness = (body, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "post",
    url: `${url}Indebtedness/AddOrUpdateIndebtedness`,
    data: body,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};

export const AddOrUpdateObligation = (body, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "post",
    url: `${url}Obligations/AddOrUpdateObligation`,
    data: body,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};

export const DeleteIndebtedness = (id, onSucess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "delete",
    url: `${url}Indebtedness/DeleteIndebtedness?IndebtednessId=${id}`,
    // data: body,
    headers,
  })
    .then((response) => {
      return onSucess(response);
    })
    .catch((err) => onFail(err));
};

export const AddOrUpdateFinancingRequest = (body, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "post",
    url: `${url}FinancingRequest/AddOrUpdateFinancingRequestForCustomer`,
    data: body,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};

export const GetAllFinancingRequests = (body, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "post",
    url: `${url}FinancingRequest/GetAllFinancingRequests`,
    data: body,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};

export const EditCustomer = (body, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "post",
    url: `${url}Customer/EditCustomer`,
    data: body,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};

export const AddOrUpdateComment = (body, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "post",
    url: `${url}Comments/AddOrUpdateComment`,
    data: body,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};

export const GetAllComments = (body, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "get",
    url: `${url}Comments/GetAllComments?FinancingRequestId=${body.Id}&Page=${body.Page}`,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};

export const DeleteComment = (id, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "delete",
    url: `${url}Comments/DeleteComment?CommentId=${id}`,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};

export const DeleteReply = (id, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "delete",
    url: `${url}Comments/DeleteReply?ReplyId=${id}`,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};

export const AddOrUpdateReply = (body, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "post",
    url: `${url}Comments/AddOrUpdateReply`,
    data: body,
    headers,
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((err) => onFail(err));
};
